// Site-wide JavaScript
// Static JavaScript extracted from view files

/* global bootstrap */

// Check if we're in a Capacitor app (mobile) or browser (desktop)
// Capacitor is only available in the mobile app, not on desktop web
(function() {
    if (window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform()) {
        document.documentElement.classList.add('app');
    } else {
        document.documentElement.classList.add('browser');
    }
})();

// Dark Mode Toggle Functionality
(function() {
    const htmlElement = document.documentElement;
    const themeKey = 'theme';

    const getCookieValue = (name) => {
        const nameEQ = name + '=';
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i];
            while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);
            if (cookie.indexOf(nameEQ) === 0) return decodeURIComponent(cookie.substring(nameEQ.length));
        }
        return null;
    };

    const setThemeCookie = (theme) => {
        const secure = window.location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = themeKey + '=' + encodeURIComponent(theme) + '; Max-Age=31536000; path=/; SameSite=Lax' + secure;
    };

    const getSavedTheme = () => {
        try {
            const savedTheme = localStorage.getItem(themeKey);
            if (savedTheme) {
                if (getCookieValue(themeKey) !== savedTheme) {
                    setThemeCookie(savedTheme);
                }
                return savedTheme;
            }
        } catch {
            // localStorage can be unavailable in some embedded/private contexts.
        }

        return getCookieValue(themeKey);
    };

    const saveTheme = (theme) => {
        try {
            localStorage.setItem(themeKey, theme);
        } catch {
            // Keep the cookie fallback below so navigation still preserves the choice.
        }

        setThemeCookie(theme);
    };
    
    // Check for saved theme preference or default to light mode
    const getTheme = () => {
        const savedTheme = getSavedTheme();
        if (savedTheme) {
            return savedTheme;
        }
        // Check system preference
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            return 'dark';
        }
        return 'light';
    };
    
    // Apply theme (can be called before DOM is ready for initial theme)
    const applyTheme = (theme, persist = false) => {
        const darkModeToggle = document.getElementById('darkModeToggle');
        const darkModeIcon = document.getElementById('darkModeIcon');
        
        if (theme === 'dark') {
            htmlElement.setAttribute('data-theme', 'dark');
            if (darkModeIcon) {
                darkModeIcon.className = 'fa-duotone fa-light fa-sun-bright';
            }
            if (darkModeToggle) {
                darkModeToggle.setAttribute('title', 'Toggle Light Mode');
                darkModeToggle.setAttribute('aria-label', 'Toggle Light Mode');
            }
        } else {
            htmlElement.removeAttribute('data-theme');
            if (darkModeIcon) {
                darkModeIcon.className = 'fa-duotone fa-regular fa-moon-stars';
            }
            if (darkModeToggle) {
                darkModeToggle.setAttribute('title', 'Toggle Dark Mode');
                darkModeToggle.setAttribute('aria-label', 'Toggle Dark Mode');
            }
        }

        if (persist) {
            saveTheme(theme);
        }
    };
    
    // Initialize theme on page load (before DOM is ready to prevent flash)
    const currentTheme = getTheme();
    applyTheme(currentTheme);
    
    // Set up click handler after DOM is ready
    const setupHandler = function() {
        const darkModeToggle = document.getElementById('darkModeToggle');
        
        // Toggle theme on button click
        if (darkModeToggle) {
            darkModeToggle.addEventListener('click', function() {
                const currentTheme = htmlElement.getAttribute('data-theme');
                const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
                applyTheme(newTheme, true);
            });
            
            // Update icon and button attributes based on current theme
            const currentTheme = htmlElement.getAttribute('data-theme');
            applyTheme(currentTheme || getTheme());
        }
    };
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupHandler);
    } else {
        // DOM already loaded, call setupHandler directly
        setupHandler();
    }
    
    // Listen for system theme changes
    if (window.matchMedia) {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        mediaQuery.addEventListener('change', function(e) {
            // Only apply system preference if user hasn't manually set a preference
            if (!getSavedTheme()) {
                applyTheme(e.matches ? 'dark' : 'light');
            }
        });
    }
})();

// Keep fixed header chrome (navbar + season alert) aligned to actual navbar height
(function() {
    const root = document.documentElement;
    let resizeTimer = null;

    function syncNavbarLayout() {
        const navbar = document.querySelector('.navbar');
        if (!navbar) {
            return;
        }

        root.style.setProperty('--navbar-height', navbar.offsetHeight + 'px');

        const noticeBar = document.querySelector('.notice-bar-alert');
        const noticeVisible = noticeBar
            && noticeBar.style.display !== 'none'
            && noticeBar.offsetParent !== null;

        if (noticeVisible) {
            root.style.setProperty('--notice-bar-height', noticeBar.offsetHeight + 'px');
            document.body.classList.add('has-notice-bar');
        } else {
            document.body.classList.remove('has-notice-bar');
        }
    }

    function scheduleNavbarLayoutSync() {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(syncNavbarLayout, 50);
    }

    function initNavbarLayoutSync() {
        syncNavbarLayout();

        window.addEventListener('resize', scheduleNavbarLayoutSync);

        const navbar = document.querySelector('.navbar');
        if (navbar && typeof ResizeObserver !== 'undefined') {
            const navbarObserver = new ResizeObserver(scheduleNavbarLayoutSync);
            navbarObserver.observe(navbar);
        }

        const navbarCollapse = document.getElementById('navbarNav');
        if (navbarCollapse) {
            navbarCollapse.addEventListener('shown.bs.collapse', syncNavbarLayout);
            navbarCollapse.addEventListener('hidden.bs.collapse', syncNavbarLayout);
        }

        const noticeBar = document.querySelector('.notice-bar-alert');
        if (noticeBar && typeof ResizeObserver !== 'undefined') {
            const noticeBarObserver = new ResizeObserver(scheduleNavbarLayoutSync);
            noticeBarObserver.observe(noticeBar);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initNavbarLayoutSync);
    } else {
        initNavbarLayoutSync();
    }

    window.syncNavbarLayout = syncNavbarLayout;
})();

// Handle notice bar dismissal with cookie and body padding
document.addEventListener('DOMContentLoaded', function() {
    const noticeBar = document.querySelector('.notice-bar-alert');
    const closeButton = document.querySelector('.notice-bar-close');
    
    // Function to update body padding based on notice bar visibility
    function updateBodyPadding() {
        if (typeof window.syncNavbarLayout === 'function') {
            window.syncNavbarLayout();
            return;
        }

        if (noticeBar && noticeBar.style.display !== 'none' && noticeBar.offsetParent !== null) {
            document.body.classList.add('has-notice-bar');
        } else {
            document.body.classList.remove('has-notice-bar');
        }
    }
    
    if (noticeBar && closeButton) {
        const cookieName = noticeBar.getAttribute('data-cookie-name');
        
        // Check if cookie exists
        if (getCookie(cookieName)) {
            noticeBar.style.display = 'none';
            updateBodyPadding();
        } else {
            // Notice bar is visible, add padding
            updateBodyPadding();
        }
        
        // Handle close button click
        closeButton.addEventListener('click', function() {
            // Set cookie for 2 days
            setCookie(cookieName, '1', 2);
            noticeBar.style.display = 'none';
            updateBodyPadding();
        });
    } else if (noticeBar) {
        // Notice bar exists but might not have close button, still update padding
        updateBodyPadding();
    }
    
    // Handle trivia bar dismissal with cookie
    const triviaBar = document.querySelector('.trivia-bar');
    const triviaCloseButton = document.querySelector('.trivia-close');
    
    if (triviaBar && triviaCloseButton) {
        const triviaCookieName = triviaBar.getAttribute('data-cookie-name');
        
        // Handle close button click
        triviaCloseButton.addEventListener('click', function() {
            // Set cookie to expire at next 1:00 AM GMT
            setCookieToNext1AMGMT(triviaCookieName, '1');
            triviaBar.style.display = 'none';
        });
    }
    
    // Cookie helper functions
    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }
    
    function setCookieHours(name, value, hours) {
        const date = new Date();
        date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }
    
    function setCookieToNext1AMGMT(name, value) {
        // Get current time
        const now = new Date();
        
        // Create date for today's 1:00 AM GMT
        const next1AM = new Date(Date.UTC(
            now.getUTCFullYear(),
            now.getUTCMonth(),
            now.getUTCDate(),
            1, 0, 0, 0
        ));
        
        // If it's already past 1:00 AM GMT today, set to tomorrow's 1:00 AM GMT
        if (next1AM <= now) {
            next1AM.setUTCDate(next1AM.getUTCDate() + 1);
        }
        
        const expires = "expires=" + next1AM.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }
    
    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    
    // Make cookie functions available globally
    window.setCookie = setCookie;
    window.setCookieHours = setCookieHours;
    window.setCookieToNext1AMGMT = setCookieToNext1AMGMT;
    window.getCookie = getCookie;
});

// Footer toggle functionality for tablet and smaller screens
document.addEventListener('DOMContentLoaded', function() {
    const footerToggleBtn = document.getElementById('footerToggleBtn');
    const footerContent = document.getElementById('footerContent');
    const footerToggleIcon = document.getElementById('footerToggleIcon');
    const mainFooter = document.getElementById('mainFooter');
    
    function updateFooterState(isCollapsed) {
        if (isCollapsed) {
            footerContent.style.display = 'none';
            footerToggleIcon.className = 'fa-duotone fa-bars';
            if (mainFooter && window.innerWidth <= 991) {
                mainFooter.classList.add('footer-collapsed');
                document.body.classList.add('footer-collapsed');
            }
        } else {
            footerContent.style.display = 'block';
            footerToggleIcon.className = 'fa-duotone fa-times';
            if (mainFooter) mainFooter.classList.remove('footer-collapsed');
            document.body.classList.remove('footer-collapsed');
        }
    }
    
    if (footerToggleBtn && footerContent) {
        // Check initial state
        const isInitiallyHidden = footerContent.getAttribute('data-initially-hidden') === 'true';
        if (isInitiallyHidden && window.innerWidth <= 991) {
            updateFooterState(true);
        }
        
        footerToggleBtn.addEventListener('click', function() {
            const isCollapsed = footerContent.style.display === 'none' || 
                               (window.innerWidth <= 991 && footerContent.style.display === '');
            updateFooterState(!isCollapsed);
        });
        
        // Handle window resize - show footer on large screens
        window.addEventListener('resize', function() {
            if (window.innerWidth >= 992) {
                footerContent.style.display = 'block';
                footerToggleIcon.className = 'fa-duotone fa-bars';
                if (mainFooter) mainFooter.classList.remove('footer-collapsed');
                document.body.classList.remove('footer-collapsed');
            } else {
                // Reapply collapsed state if footer was collapsed
                if (footerContent.style.display === 'none') {
                    if (mainFooter) mainFooter.classList.add('footer-collapsed');
                    document.body.classList.add('footer-collapsed');
                }
            }
        });
    }
});

// Close navbar menu when clicking outside
document.addEventListener('DOMContentLoaded', function() {
    const navbarToggler = document.querySelector('.navbar-toggler');
    const navbarCollapse = document.getElementById('navbarNav');
    
    if (navbarToggler && navbarCollapse) {
        // Listen for clicks on the document
        document.addEventListener('click', function(event) {
            // Check if the click is outside the navbar
            const isClickInsideNavbar = event.target.closest('.navbar');
            
            // Check if navbar is currently open (has 'show' class)
            const isNavbarOpen = navbarCollapse.classList.contains('show');
            
            // If navbar is open and click is outside, close it
            if (isNavbarOpen && !isClickInsideNavbar) {
                // Use Bootstrap's collapse API to hide
                const bsCollapse = bootstrap.Collapse.getInstance(navbarCollapse);
                if (bsCollapse) {
                    bsCollapse.hide();
                } else {
                    // Fallback: manually hide if Bootstrap instance doesn't exist
                    navbarCollapse.classList.remove('show');
                }
            }
        });
    }
});

// Notice Bar functionality
document.addEventListener('DOMContentLoaded', function() {
    var noticeBar = document.getElementById('noticeBar');
    if (!noticeBar) {
        return;
    }
    
    var footer = document.getElementById('mainFooter');
    
    // Function to update footer margin based on notice bar visibility
    function updateFooterMargin() {
        if (footer) {
            if (noticeBar.style.display === 'none' || noticeBar.offsetParent === null) {
                footer.classList.remove('has-notice-bar');
            } else {
                footer.classList.add('has-notice-bar');
            }
        }
    }
    
    // Check if notice bar was closed in the last 24 hours
    var noticeClosedKey = 'noticeBarClosed';
    var closedData = localStorage.getItem(noticeClosedKey);
    
    if (closedData) {
        try {
            var closedInfo = JSON.parse(closedData);
            var closedTime = new Date(closedInfo.timestamp);
            var now = new Date();
            var hoursDiff = (now - closedTime) / (1000 * 60 * 60);
            
            // If less than 24 hours, don't show the notice
            if (hoursDiff < 24) {
                updateFooterMargin();
                return;
            } else {
                // Remove expired entry
                localStorage.removeItem(noticeClosedKey);
            }
        } catch {
            // If parsing fails, remove the invalid entry
            localStorage.removeItem(noticeClosedKey);
        }
    }
    
    // Show the notice bar
    noticeBar.style.display = 'block';
    updateFooterMargin();
    
    // Handle close button click
    var closeBtn = noticeBar.querySelector('.notice-close');
    if (closeBtn) {
        closeBtn.addEventListener('click', function() {
            noticeBar.style.display = 'none';
            updateFooterMargin();
            
            // Store close timestamp in localStorage
            var closeInfo = {
                timestamp: new Date().toISOString()
            };
            localStorage.setItem(noticeClosedKey, JSON.stringify(closeInfo));
        });
    }
});

// Prevent links from opening in external browser (Capacitor/iOS)
document.addEventListener('DOMContentLoaded', function() {
    // Check if we're in a Capacitor app or standalone mode
    const isCapacitor = window.Capacitor !== undefined;
    const isStandalone = window.navigator.standalone === true;
    
    // Intercept all link clicks
    document.addEventListener('click', function(e) {
        const link = e.target.closest('a');
        
        if (!link) return;
        
        const href = link.getAttribute('href');
        if (!href) return;
        
        // Skip external links, mailto, tel, etc.
        if (href.startsWith('http://') || href.startsWith('https://')) {
            // Check if it's the same origin or our server URL
            const currentOrigin = window.location.origin;
            const linkUrl = new URL(href, window.location.href);
            
            // If it's a different domain, allow default behavior (external link)
            if (linkUrl.origin !== currentOrigin && 
                !linkUrl.hostname.includes('marcher.loc') && 
                !linkUrl.hostname.includes('drumcorpsthegame.com')) {
                return; // Allow external links to open normally
            }
        }
        
        // Skip special protocols
        if (href.startsWith('mailto:') || 
            href.startsWith('tel:') || 
            href.startsWith('javascript:') ||
            href.startsWith('#')) {
            return;
        }
        
        // For same-origin links in app mode, prevent default and navigate
        if (isCapacitor || isStandalone) {
            e.preventDefault();
            
            // Convert absolute URLs to relative paths
            let targetUrl = href;
            if (href.startsWith('http://') || href.startsWith('https://')) {
                try {
                    const url = new URL(href);
                    targetUrl = url.pathname + url.search + url.hash;
                } catch {
                    // If URL parsing fails, use as-is
                }
            }
            
            // Navigate within the app
            window.location.href = targetUrl;
        }
    }, true); // Use capture phase to catch all clicks
});

// Clear biometric credentials on logout
document.addEventListener('DOMContentLoaded', function() {
    const logoutLinks = document.querySelectorAll('a[href*="logout"]');
    logoutLinks.forEach(function(link) {
        link.addEventListener('click', async function() {
            // Clear biometric credentials when logging out
            if (window.biometricAuth && window.biometricAuth.isCapacitor) {
                try {
                    await window.biometricAuth.clearStoredCredentials();
                } catch {
                    // Error clearing biometric credentials
                }
            }
            // Allow the logout link to proceed normally
        });
    });
});
